import { AnalyticsBrowser } from '@segment/analytics-next'
import { FC, ReactNode } from 'react'

import { AnalyticsContext } from './context'

export const AnalyticsProvider: FC<{
  analytics: AnalyticsBrowser
  children: ReactNode
}> = ({ children, analytics }) => {
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  )
}
